import React from 'react';
import { PROFILE } from '../data/profile';
import Icon from './Icons';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p>© {new Date().getFullYear()} {PROFILE.name} · <a href={`mailto:${PROFILE.email}`}>{PROFILE.email}</a></p>
        <div className="footer__links">
          <a href={PROFILE.githubUrl} target="_blank" rel="noopener noreferrer" aria-label="GitHub"><Icon name="github" /></a>
          <a href={PROFILE.linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><Icon name="linkedin" /></a>
          <a href={PROFILE.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Icon name="instagram" /></a>
          <a href={`mailto:${PROFILE.email}`} aria-label="Email"><Icon name="mail" /></a>
        </div>
      </div>
    </footer>
  );
}
